import React, { useState } from 'react';
import {Redirect, Link} from 'react-router-dom';
import Stylesheet from './Login.module.css';
import {UserContext} from '../../contexts/user';
import {AppContext} from '../../contexts/app';
import Button from '../../elements/Button/Button';
import { ico_laugh_squint, ico_surpries, ico_times, ico_database } from '../../icon';
import Email from '../../elements/Email/Email';
import Password from '../../elements/Password/Password';
import {user} from '@enigma/core/services';

const Login = (props) => {
    // update window title
    document.title = 'Login';
    let app = null;
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [loading, setLoading] = useState(false);

    const Login = async _ => {
        // peform validations
        if (!email || email === '') {
            app.toggleToast(ico_surpries, 'email can not be empty.', true);
            return;
        }
        // check if password has been entered
        if (!password || password === '') {
            app.toggleToast(ico_laugh_squint, 'password can not be empty.', true);
            return;
        }
        // disable loging button
        setLoading(true);
        // sliently logn user
        await user
        .signInWithEmailAndPassword(email, password)
        .catch(error => {
            if (error === 'user-not-found')
            app.toggleToast(ico_times, 'account not found', true);
            else if (error === 'wrong-password')
            app.toggleToast(ico_times, 'password incorrect', true);
            else if (error === 'user-disabled')
            app.toggleToast(ico_times, 'account has been blocked', true);
            else if (error === 'invalid-email')
            app.toggleToast(ico_times, 'invalid email address', true);
            setLoading(false);
        })
    }

    const content = () => {
        return (
            <form className={Stylesheet.Login} onSubmit={event => {
                event.preventDefault();
                Login() }}>
                <div className={Stylesheet.Logo}>
                    <h1>{ico_database}</h1>
                </div>
                <h2  className={Stylesheet.Title}>
                Fleet Managment Console</h2>
                <h4 className={Stylesheet.Subtitle}>
                login with your organization cridentials.</h4>
                <div className={Stylesheet.Field}>
                    <Email icon 
                    
                    onChange={value => setEmail(value)} />
                </div>
                <div className={Stylesheet.Field}>
                    <Password icon 
                    onChange={value => setPassword(value)}/>
                </div>
                <div className={Stylesheet.Controls}>
                    <div className={Stylesheet.Control}>
                        <Button secondary
                        type="submit"
                        loading={loading}>
                        Login</Button>
                    </div>
                </div>
                <h5 className={Stylesheet.Signup}>
                are you an employee?, 
                &nbsp;<Link to="/register">register here</Link>.</h5>
            </form>
        )
    }

    const init = (appContext) => {
        app = appContext;
    }

    return (
        <UserContext.Consumer>
            {user => (
                <AppContext.Consumer>
                    {app => (
                        <div className={Stylesheet.Container}>
                            {user.profile ? <Redirect to='/' /> : null}
                            {init(app)}
                            {content()}
                            <h6 className={Stylesheet.Copyright}>
                            &copy;enigmasoftworks 2021.
                            &nbsp;<span>all</span> rights reserved.</h6>
                        </div>
                    )}
                </AppContext.Consumer>
            )}
        </UserContext.Consumer>
    )
}

export default Login;